// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type TabsState = {
    [key: string]: boolean;
};

const initialXTabsState: TabsState = {};

const xTabs = createTypedReducerWithImmer(initialXTabsState, {
    "xTabs/EnableZone": (draft: Draft<TabsState>, action: { data: { zone: string; isEnabled: boolean } }) => {
        draft[action.data.zone] = action.data.isEnabled;
    },
    "xTabs/EnableZones": (
        draft: Draft<TabsState>,
        action: { data: { zonesState: { name: string; isEnabled: boolean }[] } },
    ) => {
        action.data.zonesState.forEach(({ name, isEnabled }) => {
            draft[name] = isEnabled;
        });
    },
});

(reducers as any).xTabs = xTabs;

export type xTabsState = {
    xTabs: TabsState;
} & ApplicationState;

type xTabsReducers = {
    tabs: typeof xTabs;
};

export type xTabsActions = Parameters<xTabsReducers[keyof xTabsReducers]>[1] | AnyAction;
